import { render, staticRenderFns } from "./fccDatasEGrupos.vue?vue&type=template&id=fbb04bf4"
import script from "./fccDatasEGrupos.vue?vue&type=script&lang=js"
export * from "./fccDatasEGrupos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports